import { Auth0Plugin, createAuth0 } from '@auth0/auth0-vue';
import { isServer } from '../Platform/Platform';
import { getLoginCallbackUrl } from '../Route/routeHelper';

let auth0Instance: Auth0Plugin | undefined;

export function createAuth0Instance(): Auth0Plugin | undefined {
  auth0Instance ??= isServer()
    ? undefined
    : createAuth0(
        {
          domain: import.meta.env.VUE_APP_DOMAIN,
          clientId: import.meta.env.VUE_APP_CLIENT_ID,
          authorizationParams: {
            audience: import.meta.env.VUE_APP_AUDIENCE,
            redirect_uri: getLoginCallbackUrl(),
          },
          useRefreshTokens: true,
          useRefreshTokensFallback: true,
          sessionCheckExpiryDays: 365, // Maximum session lifetime
        },
        { skipRedirectCallback: true },
      );

  return auth0Instance;
}
